import React, { memo } from 'react';
import { Box, IconButton } from '@mui/material';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
import CustomTooltip from '../../../components/CustomTooltip';

const views = [
  { key: 'list',  icon: ViewListRoundedIcon,   tooltip: 'List view'  },
  { key: 'board', icon: ViewColumnRoundedIcon,  tooltip: 'Board view' },
];

const ViewToggle = ({ active, onChange }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#F0F1F3',
      borderRadius: '8px',
      p: '3px',
      gap: '2px',
    }}
  >
    {views.map(({ key, icon: Icon, tooltip }) => {
      const isActive = active === key;
      return (
        <CustomTooltip key={key} title={tooltip}>
          <IconButton
            size="small"
            onClick={() => { if (!isActive && onChange) onChange(key); }}
            sx={{
              borderRadius: '6px',
              width: { xs: 28, lg: 32 },
              height: { xs: 28, lg: 32 },
              backgroundColor: isActive ? '#fff' : 'transparent',
              boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
              color: isActive ? '#1E1E2D' : '#999',
              transition: 'all 0.15s ease',
              '&:hover': {
                backgroundColor: isActive ? '#fff' : 'rgba(0,0,0,0.04)',
                color: isActive ? '#1E1E2D' : '#666',
              },
            }}
          >
            <Icon sx={{ fontSize: { xs: '16px', lg: '18px' } }} />
          </IconButton>
        </CustomTooltip>
      );
    })}
  </Box>
);

export default memo(ViewToggle);
